import React from 'react'
// Logos
import { ReactComponent as LogoBlack } from './icons/logo-black.svg'
import { ReactComponent as Logo } from './icons/logo.svg'

function PoweredBy({ className = '', dark = false }) {
  return (
    <div className={`flex items-center shrink-0 relative z-[10] ${className}`}>
      <span >Powered by</span>{' '}
      <div className="ml-[6px]">
        <div className="mt-[3px]">
          <div className="w-[52px]">{dark ? <LogoBlack /> : <Logo />} </div>
        </div>
      </div>
    </div>
  )
}

export default PoweredBy
